// import Footer from "../../components/footer/Footer.tsx";
// import Header from "../../components/header/Header.tsx";
// import Navbar from "../../components/navbar/Navbar.tsx";
import coinImg from "../../assets/images/coin.svg";
import { useNavigate } from "react-router-dom";

const EPara = () => {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col min-h-screen">
      {/* <Header />
      <Navbar /> */}
      <main className="flex-grow">
        {/* Title and left image*/}
        <div className="flex flex-row mx-auto md:w-auto mt-8 mb-4">
          <div className="w-9/12 md:w-9/12 ml-16 justify-center mt-2 md:mt-6 flex md:justify-center 2xl:ml-96 md:ml-40 lg:ml-64">
          <h1 className="text-center text-2xl md:text-4xl font-bold ml-2">
            E-para Nedir?
          </h1>
          </div>

          <div className="w-3/12 md:w-3/12 justify-center flex flex-row mr-3 md:mr-6 2xl:mr-12 lg:mr-10">
          <img
            src={coinImg}
            alt="Coin Image"
            className=" max-h-12 md:max-h-20 mr-3"
          />
          </div>
        </div>

        {/* Texts and Button */}

        <div className="border mx-auto w-3/4 rounded-lg mb-8 lg:mb-16">
          <div className="flex flex-col items-center justify-center mx-auto w-3/4 my-8 lg:my-16">
            <p>
              Eczane Kampanya Uygulaması olarak, müşterilerimize daha kolay ve
              avantajlı alışveriş deneyimi sunmak için yeni bir adım attık:
              E-Para! Artık sağlık ürünlerinizi satın alırken, alışverişinizi
              daha kolay hale getirmek için dijital bir ödeme yöntemi sunuyoruz.
              E-Para, uygulamamız içinde kullanabileceğiniz özel bir dijital
              para birimidir. Hem kullanıcı dostu hem de güvenli olan bu sistem,
              alışverişlerinizde size hız ve kolaylık sağlar. Üstelik, sık sık
              düzenlediğimiz kampanyalarla birlikte E-Para kazanabilir ve bu
              parayı alışverişlerinizde kullanabilirsiniz. E-Para'nın
              avantajlarından bazıları şunlardır:
            </p>
            <ul>
              <li>
                Hızlı ve Güvenli Ödemeler: Sıra beklemeden, tek bir tıklamayla
                ödemenizi tamamlayın.
              </li>
              <li>
                Kazançlı Kampanyalar: Uygulamamız içinde düzenlediğimiz
                kampanyalardan yararlanarak E-Para kazanın.
              </li>
              <li>
                Esnek Kullanım: E-Para'yı uygulamamız içindeki tüm ürünlerde ve
                hizmetlerde kullanabilirsiniz.
              </li>
              <li>
                Sadakat Ödülleri: Daha fazla alışveriş yaptıkça, daha fazla
                E-Para kazanın ve ödüllerin tadını çıkarın.
              </li>
            </ul>

            <p>
              E-Para ile alışveriş yapmak çok kolay! Uygulamamızı indirin,
              hesabınızı oluşturun ve hemen alışverişe başlayın. Sağlıklı ve
              mutlu alışverişler dileriz!
            </p>

            <h1 className="text-3xl font-bold my-4 lg:my-8">
              Nasıl Kazanırım?
            </h1>

            <p>
              Eczane Kampanya Uygulaması olarak, müşterilerimize daha kolay ve
              avantajlı alışveriş deneyimi sunmak için yeni bir adım attık:
              E-Para! Artık sağlık ürünlerinizi satın alırken, alışverişinizi
              daha kolay hale getirmek için dijital bir ödeme yöntemi sunuyoruz.
              E-Para, uygulamamız içinde kullanabileceğiniz özel bir dijital
              para birimidir. Hem kullanıcı dostu hem de güvenli olan bu sistem,
              alışverişlerinizde size hız ve kolaylık sağlar. Üstelik, sık sık
              düzenlediğimiz kampanyalarla birlikte E-Para kazanabilir ve bu
              parayı alışverişlerinizde kullanabilirsiniz. E-Para'nın
              avantajlarından bazıları şunlardır:
            </p>
          </div>

          <div className="flex justify-center my-2 lg:my-4">
            <button 
            className="mt-5 bg-primary-color hover:bg-color-gray text-white hover:border-2 hover:border-primary-color hover:text-primary-color py-3 px-36 rounded-full"
            onClick={() => navigate('/profile/special')}
            >
              E-Para Alışveriş
            </button>
          </div>
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default EPara;
